import { RefObject, useEffect, useRef } from 'react';
import { Outlet } from 'react-router-dom';
import { PermissionEnum, PermissionDenied } from '@ui/src';
import { useAppSelector } from '@store';
import usePortal from './hooks/use-portal';

import cn from './styles.module.css';

const ChartsOfAccounts = () => {
  const ref = useRef<HTMLDivElement | null>(null);

  usePortal(ref as RefObject<HTMLDivElement>);

  const { activePermissions } = useAppSelector((state) => state.root);

  useEffect(() => {
    let title = 'Chart of accounts';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  let content;

  if (!activePermissions?.includes(PermissionEnum.ACCOUNTS_CHART)) {
    content = <PermissionDenied />;
  } else {
    content = (
      <div className={cn.columns} ref={ref}>
        <Outlet />
        <div id="chart-modal" className={cn.chartModal} />
      </div>
    );
  }

  return content;
};

export default ChartsOfAccounts;
